import React from "react";
import { Link } from "react_reusable_components";
import MyAccountViewContainer from "../../containers/MyAccountViewContainer";
import MyAccountLayout from "../../layouts/MyAccountLayout";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";

export default function MyAccountView() {
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <MyAccountLayout
      topSection={
        <Link
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
          type="backNavigation"
          href="#"
          iconSrc={"/icons/arrow_back.svg"}
          labelText={getLocalizedMessage(
            intl,
            "account.heading.myAccountDetails"
          )}
        />
      }
      bottomSection={<MyAccountViewContainer />}
    />
  );
}
